import * as React from 'react';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

// Utils
import { useTranslation } from 'react-i18next'
import { InputContainer, InputText } from './styles';

export const SearchBarWorkflow = ({
    handleChangeFilters,
    handleFilters,
    clearFilter,
    workflow,
    initialValue = ''
}) => {
    const { t } = useTranslation();
    const [search, setSearch] = React.useState('')

    function handleSearch(e) {
        setSearch(e)
        handleChangeFilters({target: {value: e}}, "filter", "text")
    }

    React.useEffect(() => {
        if (!initialValue) {
            handleSearch("")
        }
    },[workflow])

    React.useEffect(() => {
      handleSearch("")
    },[clearFilter?.current])

    React.useEffect(() => {
        if (initialValue?.toString() !== search?.toString()) {
            handleSearch(initialValue?.toString() || "");
        }
    }, [initialValue])

    return (
        <InputContainer
            component="form"
            elevation={0}
        >
            <IconButton type="button" sx={{ p: '5px' }} aria-label="search" disabled>
              <SearchIcon />
            </IconButton>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <InputText
                type='text'
                name='search'
                value={search}
                autoComplete='off'
                onChange={e => handleSearch(e.target.value)}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleFilters()
                  }
                }}
                placeholder={t('common.searchBars.workflow')}
                inputProps={{ 'aria-label': 'search google maps' }}
            />
        </InputContainer>
    );
}